import axios from "axios";
import apiConfig from "./apiconfig";

const axiosClient = axios.create({
  baseURL: apiConfig.BASE_URL,
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("API Error:", error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default axiosClient;
